export default "__VITE_ASSET__IeCrV0ET__"